import { useEffect, useState } from "react";
import { VehicleService } from "../../../core/services/VehicleService";
import { Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useFormatDate } from "../../../core/hooks/useFormatDate";
import TableFooter from "../../../components/TableFooter";

interface EmbedIntelligenceRulesProps {
    vehicleId?: number
}

const EmbedIntelligenceRules: React.FC<EmbedIntelligenceRulesProps> = ({ vehicleId }) => {
    const { t } = useTranslation();
    const [rules, setRules] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(15); // Number of items per page
    const { validateDateFormatAndTime } = useFormatDate();

    async function loadEmbedRules() {
        if (vehicleId) {
            const result = await VehicleService.loadGeofenceSecurityRule(vehicleId);
            setRules(result.data.security_rules);
        }
    }

    useEffect(() => {
        loadEmbedRules();
    }, [vehicleId]);

    // Calculate the paginated data
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentRules = rules.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rules.length / itemsPerPage);

    return (
        <Row className="m-3">
            <h6>{t("vehicles.hardware.embed_intelligence_rules.title")}</h6>
            <Table responsive className="mt-4">
                <thead>
                    <tr>
                        <th>{t("vehicles.hardware.embed_intelligence_rules.rule_name")}</th>
                        <th>{t("vehicles.hardware.embed_intelligence_rules.generation_date")}</th>
                        <th>{t("vehicles.hardware.embed_intelligence_rules.embark_date")}</th>
                        <th>{t("vehicles.hardware.embed_intelligence_rules.rule_group")}</th>
                    </tr>
                </thead>
                <tbody>
                    {currentRules.map((rule: any, index: number) => (
                        <tr key={index}>
                            <td>{rule.name}</td>
                            <td>{validateDateFormatAndTime(rule.association_date)}</td>
                            <td>{rule.embarked_date ? validateDateFormatAndTime(rule.embarked_date) : '-'}</td>
                            <td>{rule.security_rule_group?.name ?? '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <TableFooter
                    hiddenAction={true}
                    paginate={{
                        current_page: currentPage,
                        qtd: totalPages,
                        onSelectPage: (page: number) => setCurrentPage(page),
                    }}
                />
        </Row>
    );
};

export default EmbedIntelligenceRules;